import { AxiosRequestConfig } from 'axios'

import { ParkingMetricsDateParams } from './types'

const buildDateParams = ({ startDate, endDate }: ParkingMetricsDateParams) => ({
  ...(startDate ? { startDate: startDate.toISOString() } : {}),
  ...(endDate ? { endDate: endDate.toISOString() } : {}),
})

const getParkingMetricsByBenefit = ({
  startDate,
  endDate,
}: ParkingMetricsDateParams): AxiosRequestConfig => ({
  url: 'dashboard/parking/metrics-by-benefit',
  method: 'GET',
  params: buildDateParams({ startDate, endDate }),
})

const getParkingMetricsByLevel = ({
  startDate,
  endDate,
}: ParkingMetricsDateParams): AxiosRequestConfig => ({
  url: 'dashboard/parking/metrics-by-level',
  method: 'GET',
  params: buildDateParams({ startDate, endDate }),
})

const getParkingMetricsByTag = ({
  startDate,
  endDate,
}: ParkingMetricsDateParams): AxiosRequestConfig => ({
  url: 'dashboard/parking/metrics-by-tag',
  method: 'GET',
  params: buildDateParams({ startDate, endDate }),
})

const getParkingMetricsByBrand = ({
  startDate,
  endDate,
}: ParkingMetricsDateParams): AxiosRequestConfig => ({
  url: 'dashboard/parking/metrics-by-brand',
  method: 'GET',
  params: buildDateParams({ startDate, endDate }),
})

export {
  getParkingMetricsByBenefit,
  getParkingMetricsByLevel,
  getParkingMetricsByTag,
  getParkingMetricsByBrand,
}
